import { Component, inject } from '@angular/core';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-toast',
  imports: [],
  template: `
    @for (toast of toast.toasts; track $index; let idx = $index) {
      <div class="toast-container position-fixed top-0 end-0 p-3">
        <div
          class="toast align-items-center border-0 show"
          [class]="{
            'text-bg-primary': toast.type === 'success',
            'text-bg-danger': toast.type === 'error',
            'text-bg-warning': toast.type === 'info'
          }"
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
        >
          <div class="d-flex">
            <div class="toast-body">{{ toast.message }}</div>
            <button
              type="button"
              class="btn-close me-2 m-auto"
              data-bs-dismiss="toast"
              aria-label="Close"
            ></button>
          </div>
        </div>
      </div>
    }
  `,
  styles: ``
})
export class ToastComponent {
  toast = inject(ToastService);

  removeToast(index: number) {
    this.toast.remove(index);
  }
}
